// ==================================================================================================
//  TECH DEBT: THIS CODE WAS TAKEN FROM https://github.com/tombolaltd/javascript-arcade
//             AND SHOULD BE REPLACED WITH A SUITABLE NPM PACKAGE ONCE AVAILABLE
// ==================================================================================================
import { Container, Graphics, Sprite } from 'pixi.js';
import { TweenLite } from 'gsap';
import { Slide } from '@/components/arcade-game/_components/how-to-play/_domain/slider/slide';
import { SliderControl } from '@/components/arcade-game/_components/how-to-play/_domain/slider/slider-control';

class SlideManager extends Container {
  protected slides: Slide[];
  protected currentSlideIndex: number;
  protected controlsContainer: Container;
  protected slideMask: Graphics;
  protected slideOutPosition: number;
  protected slideInPosition: number;
  protected swipeRegion: Sprite;
  protected swipeThreshold: number;
  protected transitionDuration: number;
  protected autoPlayTransitionDuration: number;
  private pointerCoords: number;

  constructor(slides: Slide[]) {
    super();

    this.slides = slides;
    this.controlsContainer = new Container();

    this.currentSlideIndex = 0;
    this.pointerCoords = 0;
    this.transitionDuration = 0.5;
    this.autoPlayTransitionDuration = 1.5;
    this.swipeThreshold = 100;

    this.slideMask = new Graphics();
    this.addChild(this.slideMask);

    const graphic = new Graphics();
    graphic.beginFill(0x000000, 0);
    graphic.drawRoundedRect(0, 0, 100, 100, 10);
    graphic.endFill();
    const texture = graphic.generateCanvasTexture();

    this.swipeRegion = new Sprite(texture);
    this.swipeRegion.interactive = true;

    this.interactive = true;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.transitionSlideLeft = this.transitionSlideLeft.bind(this);
    this.transitionSlideRight = this.transitionSlideRight.bind(this);
    this.transitionSlideIn = this.transitionSlideIn.bind(this);
    this.changeSlide = this.changeSlide.bind(this);

    this.swipeRegion.on('pointerdown', this.onPointerDown);
  }

  protected addSlide(slide: Container) {
    this.addChild(slide);
  }

  protected changeSlide(slideIndex: number): void {
    if (this.currentSlideIndex === 0 && slideIndex === this.slides.length - 1) {
      this.transitionSlideLeft(false, true);
    }
    else if (this.currentSlideIndex === this.slides.length - 1 && slideIndex === 0) {
      this.transitionSlideRight(false, true);
    }
    else if (slideIndex < this.currentSlideIndex) {
      this.transitionSlideRight();
    }
    else {
      this.transitionSlideLeft();
    }
  }

  protected transitionSlideLeft(useAutoPlaySpeed: boolean = false, goToLastSlide: boolean = false): void {
    let slideIndex = this.currentSlideIndex === this.slides.length - 1 ? 0 : this.currentSlideIndex + 1;
    const duration = useAutoPlaySpeed ? this.autoPlayTransitionDuration : this.transitionDuration;

    if (goToLastSlide) {
      slideIndex = this.slides.length - 1;
    }

    this.slides[slideIndex].position.x = this.slideOutPosition;

    TweenLite.to(this.slides[this.currentSlideIndex].position, duration, {
      x: -this.slideOutPosition
    });

    this.currentSlideIndex = slideIndex;
  }

  protected transitionSlideRight(useAutoPlaySpeed: boolean = false, goToFirstSlide: boolean = false): void {
    let slideIndex = this.currentSlideIndex === 0 ? this.slides.length - 1 : this.currentSlideIndex - 1;
    const duration = useAutoPlaySpeed ? this.autoPlayTransitionDuration : this.transitionDuration;

    if (goToFirstSlide) {
      slideIndex = 0;
    }

    this.slides[slideIndex].position.x = -this.slideOutPosition;

    TweenLite.to(this.slides[this.currentSlideIndex].position, duration, {
      x: this.slideOutPosition
    });

    this.currentSlideIndex = slideIndex;
  }

  protected updateControls(): void {
    const controlsContainer = (this.controlsContainer.children as SliderControl[]);
    controlsContainer.forEach((control) => {
      control.disable();
    });

    controlsContainer[this.currentSlideIndex].enable();
  }

  protected transitionSlideIn(): void {
    this.updateControls();

    TweenLite.to(this.slides[this.currentSlideIndex].position, this.transitionDuration, {
      x: this.slideInPosition,
      immediateRender: true
    });
  }

  protected applyMask(xPosition: number, yPosition: number, width: number, height: number): Graphics {
    this.slideMask.beginFill(0x000000, 0);
    this.slideMask.drawRect(xPosition, yPosition, width, height);
    this.slideMask.endFill();

    return this.slideMask;
  }

  protected onPointerDown(e: PIXI.interaction.InteractionEvent): void  {
    this.pointerCoords = e.data.global.x;

    this.swipeRegion.on('pointerup', this.onPointerUp);
    this.swipeRegion.on('pointerout', this.onPointerUp);
    this.swipeRegion.on('pointermove', this.onPointerMove);
  }

  protected onPointerMove(e: PIXI.interaction.InteractionEvent): void {
    this.slides[this.currentSlideIndex].position.x = (e.data.global.x - this.pointerCoords) + this.slideInPosition;
  }

  protected onPointerUp(e: PIXI.interaction.InteractionEvent): void  {
    const distance = this.slides[this.currentSlideIndex].position.x - this.slideInPosition;
    if (distance > this.swipeThreshold || distance < -this.swipeThreshold) {
      if (this.slides[this.currentSlideIndex].position.x > this.slideInPosition) {
        this.transitionSlideRight();
      }
      else {
        this.transitionSlideLeft();
      }
    }

    this.swipeRegion.off('pointermove', this.onPointerMove);
    this.swipeRegion.off('pointerup', this.onPointerUp);
    this.swipeRegion.off('pointerout', this.onPointerUp);

    this.transitionSlideIn();

    this.pointerCoords = 0;
  }

  public destroy(): void {
    this.swipeRegion.off('pointerdown', this.onPointerDown);
    super.destroy();
  }
}

export { SlideManager };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/arcade-game/_components/how-to-play/_domain/slider/slide-manager.ts